import { render, staticRenderFns } from "./SubjectSelectButton.vue?vue&type=template&id=3da2135e&scoped=true&lang=pug&"
import script from "./SubjectSelectButton.vue?vue&type=script&lang=ts&"
export * from "./SubjectSelectButton.vue?vue&type=script&lang=ts&"
import style0 from "./SubjectSelectButton.vue?vue&type=style&index=0&id=3da2135e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da2135e",
  null
  
)

export default component.exports